import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import { useQuery } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import { useCompanies } from '@/hooks/use-companies'
import { getEconomyReports } from '@/services/get-economy-reports'

export const GET_ECONOMY_REPORTS_QUERY = 'GET_ECONOMY_REPORTS_QUERY'

export const useGetEconomyReports = () => {
  const { selectedCompany } = useCompanies()

  const query = useQuery({
    queryKey: [GET_ECONOMY_REPORTS_QUERY, selectedCompany.id],
    queryFn: ({ signal }) => getEconomyReports(selectedCompany.id, { signal }),

    select: (reports) =>
      reports.map((report) => ({
        ...report,
        created_at: new Date(report.created_at).toLocaleDateString('pt-BR'),
        start_date: new Date(report.start_date).toLocaleDateString('pt-BR'),
        end_date: new Date(report.end_date).toLocaleDateString('pt-BR'),
      })),
    onError: () =>
      toast.error(
        'Não foi possível carregar as informações. Tente novamente.',
        {
          icon: <ErrorOutlineIcon />,
        },
      ),
  })

  return query
}
